import type { RichTextProps } from '../types';

export function getArrayOfElements(content: RichTextProps['content']) {
  return Array.isArray(content) ? content : content.children;
}
